import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const FilterIconFilled: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={svgWidth}
            height={svgHeight}
            fill="none"
            viewBox="0 0 24 24"
            {...restProps}
        >
            <path
                fill={color}
                d="M19.846 3.78a1.413 1.413 0 00-.5-.57 1.288 1.288 0 00-.704-.21H5.357a1.29 1.29 0 00-.704.21 1.415 1.415 0 00-.5.57 1.533 1.533 0 00.092 1.5l.02.031 5.63 7.893V20.1c0 .163.041.323.12.463.078.14.19.254.324.33a.797.797 0 00.865-.044l2.526-1.8a.883.883 0 00.275-.324c.065-.131.1-.277.1-.425v-5.097l5.649-7.92a1.532 1.532 0 00.092-1.503z"
            ></path>
        </svg>
    );
};

export default React.memo(FilterIconFilled);
